// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2W6PU","empty":"ModalGraph_empty__fO4jl"};